import React from 'react';
import { WeaningFeedbackView, WeaningFeedbackData } from '../modules/farm/components/WeaningFeedbackView';

// Dados de exemplo baseados no retorno fornecido pelo usuário
const exampleWeaningData: WeaningFeedbackData = {
  data: {
    message: "Animal '076999400704676' já foi desmamado anteriormente",
    content_type: "desmama",
    status: "COMPLETO",
    name: "Rosa",
    breed_code: "nelore",
    gender: "Fêmea",
    birth_date: "2024-09-19",
    weight_kg: 335,
    weaning_date: "2025-09-19",
    handling_date: "2025-09-19",
    missing_fields: [],
    cattle_tag: "076999400704676",
    operation_code: "desmama",
    summary: "Desmama registrada para a vaca Rosa",
    age_months: 12,
    paddock: "pasto 1"
  },
  resumo: "Animal Rosa cadastrado com sucesso.",
  url: "/animal/detalhes"
};

const WeaningFeedbackExample: React.FC = () => {
  return (
    <div style={{ height: '100vh', backgroundColor: '#f5f5f5' }}>
      <WeaningFeedbackView weaningData={exampleWeaningData} />
    </div>
  );
};

export default WeaningFeedbackExample;